import { render, staticRenderFns } from "./re-captcha.vue?vue&type=template&id=087da068&"
import script from "./re-captcha.vue?vue&type=script&lang=js&"
export * from "./re-captcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports